import { RichText } from "../product/RichText";

const parse = (body = "") => body.split("\n").map((l) => l.trim()).filter((l) => l.includes("|")).map((l) => l.split("|").map((c) => c.trim()));

// Vergelijkingstabel uit beheerbare tekst ("Kenmerk | A | B" per regel, eerste regel = kop). Mobiel: kaarten per rij.
export const CompareTable = ({ body, caption, testid }) => {
  const [head, ...rows] = parse(body);
  if (!head || !rows.length) return null;
  return (
    <div data-testid={testid}>
      <div className="hidden overflow-hidden rounded-2xl border border-slate-200 bg-white md:block" style={{ boxShadow: "var(--shadow-1)" }}>
        <table className="w-full border-collapse text-left text-[14.5px]">
          {caption && <caption className="sr-only">{caption}</caption>}
          <thead className="bg-slate-50">
            <tr>{head.map((h, i) => <th key={h} scope="col" className={`px-5 py-3.5 text-[13px] font-semibold uppercase tracking-wide ${i ? "text-ink" : "text-slate-500"}`}>{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r[0]} className="align-top transition-colors hover:bg-slate-50/60">
                <th scope="row" className="w-[24%] px-5 py-4 font-semibold text-ink">{r[0]}</th>
                {r.slice(1).map((c, i) => <td key={i} className="px-5 py-4 leading-relaxed text-slate-700"><RichText text={c} /></td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ul className="grid gap-3 md:hidden">
        {rows.map((r) => (
          <li key={r[0]} className="card p-4">
            <p className="text-[15px] font-semibold text-ink">{r[0]}</p>
            <dl className="mt-2 grid gap-2">
              {r.slice(1).map((c, i) => (
                <div key={i}><dt className="text-[12px] font-semibold uppercase tracking-wide text-gold">{head[i + 1]}</dt><dd className="text-[14.5px] leading-relaxed text-slate-700"><RichText text={c} /></dd></div>
              ))}
            </dl>
          </li>
        ))}
      </ul>
    </div>
  );
};
